
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom"; 
import "./index.css";
import App from "./App";
import store, { persistor } from "./store/store";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
          <React.StrictMode>
            <App />
          </React.StrictMode>
      </Router>
    </PersistGate>
  </Provider>
);

reportWebVitals();
